import { useNavigate } from 'react-router-dom';
import { WsButton, WsTitleBanner } from 'wisestep-base';

const UploadDeviceHeader = () => {
  const navigate = useNavigate();
  const navigateImportCandidates = () => navigate('/import-candidates');
  return (
    <WsTitleBanner
      title="Bulk Upload Candidate Profiles"
      goBack={navigateImportCandidates}
      rightChildren={
        <WsButton
          variant="contained"
          onClick={() => navigate('/import-candidates/bulk-upload-report')}
          size="small"
        >
          Upload History
        </WsButton>
      }
    />
  );
};
export default UploadDeviceHeader;
